import styled, { css } from 'styled-components';
import { Typography } from 'modules/v2/foundation/Typography';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { interactiveTransition, themeGet } from 'modules/v2/foundation/theme';
const flexStyles = css `
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: ${themeGet('spacing.md')};
`;
export const buttonBase = css `
  appearance: none;
  text-decoration: none;
  box-sizing: border-box;

  font-style: normal;
  font-weight: ${themeGet('fontWeight.medium')};
  font-size: ${themeGet('fontSize.medium')};
  line-height: ${themeGet('lineHeight.default')};

  border-style: solid;
  border-width: ${pxToRem(1)};
  border-radius: ${themeGet('borderRadius.md')};

  ${flexStyles};

  &:disabled {
    pointer-events: none;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:focus-visible {
    outline: none;
  }

  ${interactiveTransition};
`;
export const StyledTypography = styled(Typography) `
  ${flexStyles}
`;
